<script lang="ts" setup>
import { useRoute } from 'vue-router'

import { actionIconsDefaultProps } from '@/components/Markets/ActionIcons/ActionIcons.constants'

import type { ActionIconsProps } from '@/components/Markets/ActionIcons/ActionIcons.types'

withDefaults(defineProps<ActionIconsProps>(), actionIconsDefaultProps)

const route = useRoute()

const emit = defineEmits<{
  (e: 'actionButtonClick'): void
}>()
</script>
<template>
  <button
    v-if="ctaButton"
    :class="{
      'lg:hidden': layout === 'horizontal'
    }"
    class="button action-icons__cta-btn"
    @click="emit('actionButtonClick')"
  >
    {{ ctaButtonTitle }}
  </button>
  <div
    :class="{
      'lg:justify-between': !noSpaceBetween,
      'justify-center': position === 'center',
      'justify-end': position === 'right'
    }"
    class="flex items-center mt-5 lg:mt-5 gap-2.5"
  >
    <button
      v-if="ctaButton && layout === 'vertical'"
      class="px-8 py-[13px] text-white bg-red-150 button rounded-[5px] block"
      @click="emit('actionButtonClick')"
    >
      {{ ctaButtonTitle }}
    </button>

    <button v-if="googlePlayButton" type="button">
      <a :href="googleLink" target="GooglePlayStore">
        <picture>
          <source
            media="(max-width: 1023px)"
            :srcset="
              googleButtonImages?.imageMobile
                ? googleButtonImages?.imageMobile
                : '/assets/google-play-mobile-trading.webp'
            "
          />
          <source
            media="(min-width: 1024px)"
            :srcset="
              googleButtonImages?.imageDesktop
                ? googleButtonImages?.imageDesktop
                : '/assets/google-play-desktop.webp'
            "
          />
          <img
            :loading="loading"
            alt="google play icon"
            :src="
              googleButtonImages?.imageDesktop
                ? googleButtonImages?.imageDesktop
                : '/assets/google-play-desktop.webp'
            "
          />
        </picture>
      </a>
    </button>

    <button v-if="appleStoreButton" type="button">
      <a :href="appleLink + '/'" target="AppleStore">
        <picture>
          <source
            media="(max-width: 1023px)"
            :srcset="
              appleButtonImages?.imageMobile
                ? appleButtonImages?.imageMobile
                : '/assets/app-store-mobile-trading.webp'
            " />
          <source
            media="(min-width: 1024px)"
            :srcset="
              appleButtonImages?.imageDesktop
                ? appleButtonImages?.imageDesktop
                : '/assets/app-store-desktop.webp'
            " />
          <img
            :loading="loading"
            alt="app store logo"
            :src="
              appleButtonImages?.imageDesktop
                ? appleButtonImages?.imageDesktop
                : '/assets/app-store-desktop.webp'
            "
        /></picture>
      </a>
    </button>
  </div>
</template>
<style lang="sass" scoped>
.action-icons__cta-btn
  @apply px-8 py-[13px] text-white bg-red-150 rounded-[5px] w-full block mt-10 md:max-w-[310px]

.social-button
  @apply w-1/2

  img
    @apply w-full

  @screen lg
    @apply w-auto

  &--large
    @apply w-1/2

    img
      @apply w-full
</style>
